import React, { useState, useEffect, useRef } from "react";
import Swiper from "swiper";
import Portal from "./portal";

const he = require("he");

const SwiperMain = () => {
  const swiperContainerRef = useRef(null); // Ref for swiper container
  const swiperInstanceRef = useRef(null);

  const [swiperData, setSwiperData] = useState(null);
  const [categoriesList, setCategoriesList] = useState([]);
  const [activeSwiperData, setActiveSwiperData] = useState([]);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const [activeSlideIndex, setActiveSlideIndex] = useState(null);
  const [activeCatIndex, setActiveCatIndex] = useState(0);

  const [activeBikeIndex, setActiveBikeIndex] = useState(1);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mobileCatListIsOpened, setMobileCatListIsOpened] = useState(false);

  const [swiperKeyCounter, setSwiperKeyCounter] = useState(0);

  const [loading, setLoading] = useState(true);
  const [loadingSwiper, setLoadingSwiper] = useState(false);

  const locationId = document
    .querySelector(".flexi-layout")
    .getAttribute("data-history-node-id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const filterDuplicates = (inputData) => {
          const uniqueTitles = new Set();
          const filteredData = [];
        
          inputData.forEach((item) => {
            const titleKey = `${item.title}_${item.title_1}`.toLowerCase(); // Combining title and title_1 fields
        
            if (!uniqueTitles.has(titleKey)) {
              uniqueTitles.add(titleKey);
              filteredData.push(item);
            }
          });
        
          return filteredData;
        };

        function aggregatePriceData(data) {
          const titlePriceMap = {};

          data.forEach((item) => {
            const priceData = {
              field_price_in_dollar: item.field_price_in_dollar || "",
              field_crossed_off_price: item.field_crossed_off_price || "",
              field_price_label: item.field_price_label || "",
            };

            if (!titlePriceMap[item.title]) {
              titlePriceMap[item.title] = [];
            }

            const existingPrice = titlePriceMap[item.title].find(
              (price) =>
                price.field_price_in_dollar === priceData.field_price_in_dollar
            );
            if (!existingPrice) {
              titlePriceMap[item.title].push(priceData);
            }
          });

          const result = data.map((item) => ({
            ...item,
            prices: titlePriceMap[item.title],
          }));

          return result;
        }

        const response = await fetch(`/rest/bike-for-rent/${locationId}`);
        const result = await response.json();

        //console.log("Raw: ", result);

        const preFilteredResult = result.filter(
          (bike) => bike.field_location === locationId && bike.title_1
        );

        //console.log("Prefilter: ", preFilteredResult);

        const locationSpecificLogic = locationId === "29124" ? "Manhattan" : "";

        const filterOutLocationSpecificBikes = preFilteredResult.filter(
          (bike) => bike.title_1 !== locationSpecificLogic
        );

        const transformedData = aggregatePriceData(
          filterOutLocationSpecificBikes
        );

        const filteredResult = filterDuplicates(transformedData);

        const uniqueCategories = [
          ...new Set(filteredResult.map((item) => item.title_1.toLowerCase())),
        ];

        const bikeCategories = uniqueCategories.map((category) => {
          const matchingItem = filteredResult.find(
            (item) => item.title_1.toLowerCase() === category
          );
          return {
            category: category,
            image: matchingItem ? matchingItem.field_bike_category_image : null,
          };
        });

        const customOption = {
          category: "all bikes",
          image:
            "/sites/default/files/bike-category-images/2019-05/hi-end%20mountain%20bikes_1.svg",
        };

        // LocationId with 36747 means manhattan if you want All bikes options comment back this line
        if (locationId === "36747") {
          //bikeCategories.unshift(customOption);
        }
        //bikeCategories.unshift(customOption);

        //console.log("main cat: ", bikeCategories);

        let filterOutCategory = bikeCategories;

        if (locationId === "29124") {
          filterOutCategory = bikeCategories.filter(
            (item) => item.category !== "manhattan"
          );
        }

        const sortedCategoryList = filterOutCategory.sort((a, b) => {
          if (a.category < b.category) {
            return -1;
          }
          if (a.category > b.category) {
            return 1;
          }
          return 0;
        });

        setCategoriesList(sortedCategoryList);

        const bikesByCategory = {};

        //if you want All bikes options comment back this line
        //bikesByCategory["all bikes"] = [];

        uniqueCategories.forEach((category) => {
          bikesByCategory[category] = [];
        });

        filteredResult.forEach((bike) => {
          if (locationId === "36747") {
            //if you want All bikes options comment back this line
            //bikesByCategory["all bikes"].push(bike);
          }
          //bikesByCategory["all bikes"].push(bike);

          const category = bike.title_1.toLowerCase();
          if (uniqueCategories.includes(category)) {
            bikesByCategory[category].push(bike);
          }
        });

        function filterOutCategoryByKey(data, categoryToFilter) {
          let filteredData = { ...data };

          if (filteredData.hasOwnProperty(categoryToFilter)) {
            delete filteredData[categoryToFilter];
          }

          return filteredData;
        }        

        const filterOurData = filterOutCategoryByKey(
          bikesByCategory,
          "Get 20% off your bike rental"
        );

        //console.log("filtered cate: ", filterOurData)

        setSwiperData(filterOurData);
        setLoading(false);

        //console.log("categories with data: ", filterOurData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [locationId]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    //console.log("swiper load: ", loadingSwiper);
  }, [loadingSwiper]);

  const initializeSwiper = () => {
    setLoadingSwiper(true);

    // Destroy existing Swiper instance if it exists
    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.destroy(true, true);
      swiperInstanceRef.current = null;
    }

    setSwiperKeyCounter((prevCounter) => prevCounter + 1);

    // Create a new Swiper instance
    const newSwiperInstance = new Swiper(
      `.swiper-container-${swiperKeyCounter}`,
      {
        slidesPerView: windowWidth > 1024 ? "auto" : 1,
        spaceBetween: 30,
        grabCursor: true,
        allowTouchMove: windowWidth > 1024 ? true : true,
        loop: true,
        initialSlide: 0,
        navigation: {
          nextEl: `.swiper-button-next-${swiperKeyCounter}`,
          prevEl: `.swiper-button-prev-${swiperKeyCounter}`,
        },
        threshold: 50,
        on: {
          slideChange: () => {
            setActiveBikeIndex(newSwiperInstance.realIndex + 1);
            console.log("changed instance: ", newSwiperInstance);
          },
          init: () => {
            setLoadingSwiper(false); // Set loading to false once swiper is initialized
          },
        },
      }
    );

    swiperInstanceRef.current = newSwiperInstance;
  };

  const initializeSwiperCat = () => {
    let mySwiperCat;

    // Destroy existing Swiper instance if it exists
    if (mySwiperCat) {
      mySwiperCat.destroy(true, true);
      mySwiper = null;
    }

    // Create a new Swiper instance
    mySwiperCat = new Swiper(".swiper-categories", {
      slidesPerView: windowWidth > 1024 ? 6 : 1,
      spaceBetween: 20,
      grabCursor: true,
      loop: false,
      navigation: {
        nextEl: ".swiper-cat-button-next",
        prevEl: ".swiper-cat-button-prev",
      },
      threshold: 50,
    });
  };

  useEffect(() => {
    if (categoriesList) {
      initializeSwiperCat();
    }
  }, [categoriesList]);

  useEffect(() => {
    if (swiperData) {
      if (locationId === "36747") {
        setActiveSwiperData(swiperData["bikes"]);
      } else {
        setActiveSwiperData(swiperData["all bikes"]);
      }
    }
  }, [swiperData]);

  useEffect(() => {
    if (activeSwiperData) {
      initializeSwiper();
    }
  }, [activeSwiperData]);

  const handleSwiperSwitch = (cat, index) => {
    setActiveSwiperData(swiperData[cat]);
    setActiveCatIndex(index);
    setActiveBikeIndex(1);
    setLoadingSwiper(true);
  };

  return (
    <div className="custom-swiper">
      <div
        ref={swiperContainerRef}
        className={`swiper-container swiper-container-${swiperKeyCounter}`}
      >
        <>
          {!loading || !loadingSwiper ? (
            <>
              <div className="swiper-wrapper">
                {activeSwiperData &&
                  activeSwiperData?.map((item, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="swiper-slide--title">{item?.title ? he.decode(item?.title) : ""}</div>
                      <div className="swiper-slide--price-details">
                        {item?.prices.map((price, index) => {
                          return (
                            <div className="single-price" key={index}>
                              {price?.field_crossed_off_price && (
                                <div className="swiper-slide--price-crossed">
                                  ${price?.field_crossed_off_price}
                                </div>
                              )}
                              <div className="swiper-slide--price">
                                ${price?.field_price_in_dollar}
                              </div>
                              <div className="swiper-slide--price-label">
                                {price?.field_price_label}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="swiper-slide--image">
                        <img src={item?.field_bike_image?.replace(/&amp;/g, "&")} alt={item?.title} />
                      </div>
                      <div className="swiper-slide--link">
                        {item?.field_fareharbor_link && <a href={item?.field_fareharbor_link}>
                          {windowWidth > 1024 ? (
                            item?.field_button_text
                          ) : (
                            <svg
                              width="32"
                              height="28"
                              viewBox="0 0 32 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M20.9138 4.96083H16.9451V0.992166C16.9451 0.444208 16.5009 0 15.953 0C15.405 0 14.9608 0.444208 14.9608 0.992166V4.96083H10.9922C10.4442 4.96083 9.99998 5.40503 9.99998 5.95299C9.99998 6.50095 10.4442 6.94516 10.9922 6.94516H14.9608V10.9138C14.9608 11.4618 15.405 11.906 15.953 11.906C16.5009 11.906 16.9451 11.4618 16.9451 10.9138V6.94516H20.9138C21.4618 6.94516 21.906 6.50095 21.906 5.95299C21.906 5.40503 21.4618 4.96083 20.9138 4.96083ZM9.38872 17.6667C9.29356 17.6667 9.20563 17.6159 9.15805 17.5335L3.12418 7.08253C2.77901 6.48467 2.01452 6.27982 1.41665 6.625C0.818786 6.97018 0.613942 7.73467 0.95912 8.33253L7.70643 20.0192C7.78544 20.1561 7.93147 20.2404 8.0895 20.2404H23.9105C24.0685 20.2404 24.2145 20.1561 24.2935 20.0192L31.0408 8.33253C31.386 7.73467 31.1812 6.97018 30.5833 6.625C29.9855 6.27982 29.221 6.48467 28.8758 7.08253L22.8419 17.5335C22.7943 17.6159 22.7064 17.6667 22.6113 17.6667H9.38872ZM11.8333 27.6667C10.4526 27.6667 9.33332 26.5474 9.33332 25.1667C9.33332 23.786 10.4526 22.6667 11.8333 22.6667C13.214 22.6667 14.3333 23.786 14.3333 25.1667C14.3333 26.5474 13.214 27.6667 11.8333 27.6667ZM20.1667 27.6667C18.7859 27.6667 17.6667 26.5474 17.6667 25.1667C17.6667 23.786 18.7859 22.6667 20.1667 22.6667C21.5474 22.6667 22.6667 23.786 22.6667 25.1667C22.6667 26.5474 21.5474 27.6667 20.1667 27.6667Z"
                                fill="white"
                              />
                            </svg>
                          )}
                        </a>}
                      </div>
                    </div>
                  ))}
              </div>

              <div className="swiper-controller">
                <div
                  className={`swiper-button-prev swiper-button-prev-${swiperKeyCounter}`}
                  onClick={() => {
                    //setActiveSlideIndex(swiperInstance.realIndex - 1);
                  }}
                >
                  <svg
                    width="27"
                    height="21"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 26.07 21.19"
                  >
                    <title>next</title>
                    <path
                      id="path-1"
                      d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                      transform="translate(0 -0.12)"
                    ></path>
                  </svg>
                </div>
                {activeSwiperData && (
                  <div className="swiper-number">
                    {activeBikeIndex}/{activeSwiperData.length}
                  </div>
                )}
                <div
                  className={`swiper-button-next swiper-button-next-${swiperKeyCounter}`}
                  onClick={() => {
                    //setActiveSlideIndex(swiperInstance.realIndex + 1);
                  }}
                >
                  <svg
                    width="27"
                    height="21"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 26.07 21.19"
                  >
                    <title>next</title>
                    <path
                      id="path-1"
                      d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                      transform="translate(0 -0.12)"
                    ></path>
                  </svg>
                </div>
              </div>
            </>
          ) : (
            <div className="react-loader">
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          )}
        </>
      </div>
      <Portal>
        <div className="temp">
          <div className="swiper-categories">
            {!loading ? (
              <>
                {windowWidth > 1024 ? (
                  <div className="swiper-wrapper">
                    {categoriesList.length > 0 &&
                      categoriesList.map((item, index) => {
                        return (
                        <div
                          className={`swiper-slide swiper-category${
                            activeCatIndex === index ? " active-cat" : ""
                          }`}
                          onClick={() => {
                            handleSwiperSwitch(item?.category, index);
                          }}
                          key={index}
                        >
                          <div className="category-image">
                            <img src={item?.image} alt={item?.category} />
                          </div>
                          <div className="category-name">
                            {item?.category ? he.decode(item.category) : ""}
                          </div>
                        </div>
                      )})}
                  </div>
                ) : (
                  <div className="mobile-swiper-categories">
                    <div
                      className={`mobile-swiper-active-cat${
                        mobileCatListIsOpened ? " cat-list-opened" : ""
                      }`}
                      onClick={() => {
                        setMobileCatListIsOpened(!mobileCatListIsOpened);
                      }}
                    >
                      <div className="active-cat-text">
                        {"Categories: "}
                        {he.decode(categoriesList?.[activeCatIndex]?.category)}
                      </div>
                      <svg
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.0416 0.673347C11.5011 0.366995 12.122 0.491169 12.4284 0.950697C12.7347 1.41023 12.6105 2.0311 12.151 2.33745L8.24403 5.60877C7.24876 6.27229 5.95443 6.28115 4.95017 5.63133L0.871258 2.34497C0.407577 2.04494 0.274911 1.42583 0.574941 0.962145C0.874971 0.498463 1.49408 0.365798 1.95776 0.665828L6.03667 3.95219C6.37143 4.1688 6.80287 4.16584 7.13463 3.94467L11.0416 0.673347Z"
                          fill="#0A0A0A"
                        />
                      </svg>
                    </div>
                    <div
                      className={`mobile-swiper-categories-list${
                        mobileCatListIsOpened ? " list-opened" : ""
                      }`}
                    >
                      {categoriesList &&
                        categoriesList?.map((item, index) => (
                          <div
                            className="mobile-swiper-cat"
                            key={index}
                            onClick={() => {
                              handleSwiperSwitch(item?.category, index);
                              setMobileCatListIsOpened(false);
                            }}
                          >
                            {he.decode(item?.category)}
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="react-loader">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </div>
          {windowWidth > 1024 && !loading && categoriesList.length > 5 ? (
            <div className="swiper-car-controller">
              <div className="swiper-cat-button-prev">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26.07 21.19"
                >
                  <title>next</title>
                  <path
                    id="path-1"
                    d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                    transform="translate(0 -0.12)"
                  ></path>
                </svg>
              </div>
              <div className="swiper-cat-button-next">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26.07 21.19"
                >
                  <title>next</title>
                  <path
                    id="path-1"
                    d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                    transform="translate(0 -0.12)"
                  ></path>
                </svg>
              </div>
            </div>
          ) : null}
        </div>
      </Portal>
    </div>
  );
};

export default SwiperMain;
